// /opt/isp_erp/frontend/src/api/finanzas/pagos.api.js
import axios from '../axios';

export const pagosApi = {
  // Listar pagos de un cliente
  listarPorCliente: (customerId, params = {}) => 
    axios.get(`/pagos/cliente/${customerId}`, { params }),

  // Obtener un pago por ID
  obtener: (id) => axios.get(`/pagos/${id}`),
  
  // Crear pago individual
  crear: (data) => axios.post('/pagos', data),
  
  // Actualizar pago
  actualizar: (id, data) => axios.put(`/pagos/${id}`, data),
  
  // Anular pago
  anular: (id, motivo) => axios.post(`/pagos/${id}/anular?motivo=${encodeURIComponent(motivo)}`),
  
  // Reporte por fechas
  reporte: (fechaDesde, fechaHasta, params = {}) => 
    axios.get('/pagos/reporte', { params: { fecha_desde: fechaDesde, fecha_hasta: fechaHasta, ...params } }),
  
  // Dashboard resumen
  dashboard: () => axios.get('/pagos/dashboard/resumen'),
  
  // Pagos masivos (Excel)
  pagosMasivos: (formData) => axios.post('/pagos/masivo', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),

  // Obtener clientes con deudas (incluye suspendidos)
  getClientesConDeudas: (search = '') =>
    axios.get(`/pagos/clientes-con-deudas?search=${search}`),

};
